(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1013],{

/***/ 51237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AnimatedInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function AnimatedInput(_ref) {
  var isPress = _ref.isPress,
      type = _ref.type,
      name = _ref.name,
      required = _ref.required,
      children = _ref.children,
      onInputChange = _ref.onInputChange,
      area = _ref.area,
      value = _ref.value;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      active = _useState[0],
      setActive = _useState[1];

  function handleActivation(e) {
    onInputChange(e);
    setActive(!!e.target.value);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "relative border-b rounded mb-2 bg-gray-600 text-gray-50 border-black border-opacity-25 truncate ",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
      value: value,
      className: [area ? "pb-20" : "", "outline-none w-full rounded ".concat(isPress ? "bg-gray-5" : "bg-transparent", "  text-sm text-gray-80 transition-all duration-200 ease-in-out p-3"), active ? "pt-6" : ""].join(" "),
      id: name,
      name: name,
      type: type,
      onChange: handleActivation
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
      className: ["absolute top-0 left-0 flex items-center text-gray-50 text-opacity-50 p-2 transition-all duration-200 ease-in-out", active ? "text-xs" : "text-sm"].join(" "),
      htmlFor: name,
      children: [children, required && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
        className: "flex items-center justify-center text-primary",
        children: "\xA0*"
      })]
    })]
  });
}

/***/ }),

/***/ 68627:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var FormikErrorMsgs = {
  required: "This field is required",
  invalidEmail: "This is not a valid email",
  invalidPhone: "This is not a valid phone",
  wrongPassword: "Password needs to be at least 8 characters long and maximum of 24 characters. It also needs to include at least one number, one special character and one uppercase letter.",
  noSpecialChars: "No special chars are allowed in this field"
};
/* harmony default export */ __webpack_exports__["Z"] = (FormikErrorMsgs);

/***/ }),

/***/ 81519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var HeadComponent = function HeadComponent(_ref) {
  var SEO = _ref.SEO;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: SEO.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: SEO.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "og:title",
      content: SEO.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "og:description",
      content: SEO.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/favicon/favicon-32x32.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/favicon/favicon-16x16.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "manifest",
      href: "/favicon/site.webmanifest"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "mask-icon",
      href: "/favicon/safari-pinned-tab.svg",
      color: "#5bbad5"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "msapplication-TileColor",
      content: "#2b5797"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "theme-color",
      content: "#ffffff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "57x57",
      href: "/favicon/apple-icon-57x57.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "60x60",
      href: "/favicon/apple-icon-60x60.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "72x72",
      href: "/favicon/apple-icon-72x72.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "76x76",
      href: "/favicon/apple-icon-76x76.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "114x114",
      href: "/favicon/apple-icon-114x114.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "120x120",
      href: "/favicon/apple-icon-120x120.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "144x144",
      href: "/favicon/apple-icon-144x144.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "152x152",
      href: "/favicon/apple-icon-152x152.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: "/favicon/apple-icon-180x180.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "192x192",
      href: "/favicon/android-icon-192x192.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/favicon/favicon-32x32.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "96x96",
      href: "/favicon/favicon-96x96.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/favicon/favicon-16x16.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "manifest",
      href: "/favicon/manifest.json"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "msapplication-TileColor",
      content: "#ffffff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "msapplication-TileImage",
      content: "/ms-icon-144x144.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "theme-color",
      content: "#ffffff"
    }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "title",
      content: SEO.title
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (HeadComponent);

/***/ }),

/***/ 52639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ agents; }
});

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./components/landing/Container.jsx + 1 modules
var Container = __webpack_require__(94964);
// EXTERNAL MODULE: ./components/landing/Head.jsx
var Head = __webpack_require__(81519);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./components/formikErrorMsgs.js
var formikErrorMsgs = __webpack_require__(68627);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./components/AnimatedInput.jsx
var AnimatedInput = __webpack_require__(51237);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./helpers/api.js
var api = __webpack_require__(47965);
// EXTERNAL MODULE: ./node_modules/react-phone-number-input/style.css
var style = __webpack_require__(15922);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var dist_es = __webpack_require__(8523);
// EXTERNAL MODULE: ./node_modules/reaptcha/dist/index.esm.js
var index_esm = __webpack_require__(46944);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/landing/AgentForm.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var Styles = {
  errorMsg: "text-red-primary text-sm"
};

var Spinner = function Spinner() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
    src: "/loading.png",
    width: 20,
    height: 20,
    alt: "spinner"
  });
};

var validationSchema = es.object().shape({
  email: es.string().email(formikErrorMsgs/* default.invalidEmail */.Z.invalidEmail).required(formikErrorMsgs/* default.required */.Z.required),
  fullName: es.string().required(formikErrorMsgs/* default.required */.Z.required),
  linkedinLink: es.string().required(formikErrorMsgs/* default.required */.Z.required),
  ReCAPTCHA: es.string().required(formikErrorMsgs/* default.required */.Z.required)
});

var AgentFormHeader = function AgentFormHeader() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "pb-12 md:pb-44 space-y-6 flex flex-col items-center lg:items-start justify-center ",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "text-xl lg:text-5xl",
      children: "Become an Agent"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "space-x-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Data Mynt Agents are compensated up to $10,000 per month to sell our products and onboard new customers while building trust and web3 awareness with local businesses. Only onboarding Agents in Nigeria, Kenya, Mexico and Philippines currently."
      })
    })]
  });
};

var AgentForm = function AgentForm(_ref) {
  var _ref$isPress = _ref.isPress,
      isPress = _ref$isPress === void 0 ? false : _ref$isPress;

  var _useState = (0,react.useState)(false),
      success = _useState[0],
      setSuccess = _useState[1];

  var _useState2 = (0,react.useState)(false),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      fileError = _useState3[0],
      setFileError = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      base64Files = _useState4[0],
      setBase64Files = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      recaptchaRef = _useState5[0],
      setRecaptchaRef = _useState5[1];

  var resetReCAPTCHA = function resetReCAPTCHA() {
    if (recaptchaRef) {
      recaptchaRef.reset();
    }
  };

  var onDrop = (0,react.useCallback)(function (acceptedFiles) {
    acceptedFiles.forEach(function (file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        setBase64Files(function (prevFiles) {
          return [].concat((0,toConsumableArray/* default */.Z)(prevFiles), [reader.result]);
        });
        setFileError(false);
      };

      reader.onabort = function () {
        return console.log("file reading was aborted");
      };

      reader.onerror = function () {
        return console.log("file reading has failed");
      };
    });
  }, []);

  var _useDropzone = (0,dist_es/* useDropzone */.uI)({
    onDrop: onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive,
      acceptedFiles = _useDropzone.acceptedFiles;

  var files = acceptedFiles.map(function (file) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
      children: [file.path, " - ", file.size, " bytes"]
    }, file.path);
  });
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      fullName: "",
      email: "",
      linkedinLink: "",
      ReCAPTCHA: "",
      agentFile: ""
    },
    validateOnChange: false,
    onSubmit: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
        var agentForm;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(base64Files.length === 0)) {
                  _context.next = 3;
                  break;
                }

                setFileError(true);
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return (0,api/* apiBecomeAnAgentForm */.Cr)({
                  name: values.fullName,
                  email: values.email,
                  linkedIn: values.linkedinLink,
                  captcha: values.ReCAPTCHA,
                  agentFile: base64Files.join("|")
                });

              case 6:
                agentForm = _context.sent;

                if (agentForm.status === 200) {
                  setSuccess(true);
                  setTimeout(function () {
                    setSuccess(false);
                    formik.resetForm();
                    resetReCAPTCHA();
                  }, 1900);
                }

                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                setError(true);
                resetReCAPTCHA();

              case 14:
                formik.resetForm();
                resetReCAPTCHA();

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }(),
    validationSchema: validationSchema,
    enableReinitialize: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mapBg  ",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden lg:flex",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AgentFormHeader, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      className: "flex flex-col h-full justify-between bg-white rounded-lg lg:rounded-none lg:mb-0 lg:rounded-t-lg shadow-lg p-7 md:p-10 w-full max-w-2xl lg:justify-self-end mt-[30px]",
      name: "agentForm",
      method: "POST",
      onSubmit: formik.handleSubmit,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: "text-black text-[18px] md:text-[24px] font-bold ",
        children: "Apply to become an Agent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        type: "hidden",
        name: "form-name",
        value: "agentForm"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatedInput/* default */.Z, {
        isPress: true,
        value: formik.values.fullName,
        type: "text",
        name: "fullName",
        required: true,
        onInputChange: formik.handleChange,
        children: "Full Name"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: formik.errors["fullName"] ? Styles.errorMsg : "hidden",
        children: formik.errors["fullName"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatedInput/* default */.Z, {
        isPress: true,
        value: formik.values.email,
        type: "text",
        name: "email",
        required: true,
        onInputChange: formik.handleChange,
        children: "Email address"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: formik.errors["email"] ? Styles.errorMsg : "hidden",
        children: formik.errors["email"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatedInput/* default */.Z, {
        isPress: true,
        value: formik.values.linkedinLink,
        type: "text",
        name: "linkedinLink",
        required: true,
        onInputChange: formik.handleChange,
        children: "Linkedin Link"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: formik.errors["linkedinLink"] ? Styles.errorMsg : "hidden",
        children: formik.errors["linkedinLink"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "".concat(isPress ? "text-white" : "text-[#22242C]", " text-[16px] font-semibold   mb-[24px] mt-[32px]"),
          children: "Please attach your CV/Resume"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", _objectSpread(_objectSpread({}, getRootProps({
          className: "dropzone"
        })), {}, {
          className: "text-black box-border h-[160px] p-6 border-2 border-dashed rounded-lg text-center gap-[8px] border-[#191B1F66]",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({}, getInputProps())), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/document-upload.svg",
            width: 20,
            height: 20,
            alt: ""
          }), base64Files.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-[#191B1F66] mt-[8px] mb-[8px]",
              children: "File uploaded successfully"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-[#0051FE] text-[14px]   ",
              children: "Click here to change"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-black text-[14px] text-[#27282F] font-[600px]",
              children: "Drag and Drop file Here"
            }), isDragActive ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Drop the files here ..."
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-[#191B1F66] mt-[8px] mb-[8px]",
                children: "or"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-[#0051FE] text-[14px]   ",
                children: "Browse File"
              })]
            })]
          })]
        }))]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: fileError ? Styles.errorMsg : "hidden",
        children: "CV/Resume is required, with size not exceeding 5MBs."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col space-y-2 items-center mt-4 -mb-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* default */.Z, {
          value: formik.values.ReCAPTCHA,
          sitekey:  true ? "6LfqUgwcAAAAAAABEclHKp9gQ4Y3b8SXpRRR7ST0" : 0,
          onVerify: function onVerify(ReCAPTCHA) {
            return formik.setFieldValue("ReCAPTCHA", ReCAPTCHA);
          },
          ref: function ref(e) {
            return setRecaptchaRef(e);
          },
          onChange: function onChange() {
            return resetReCAPTCHA(true);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: formik.errors["ReCAPTCHA"] ? Styles.errorMsg : "",
          children: formik.errors["ReCAPTCHA"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center justify-center mt-4",
        children: [formik.isSubmitting ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "submit",
          className: "bg-[#22242C] w-full px-8 py-2 text-white rounded-[38px] font-bold text-[16px] mt-[40px]",
          children: "Submit your application"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: formik.errors["check"] ? Styles.errorMsg : "",
          children: formik.errors["check"]
        })]
      }), success && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-primary",
        children: "Your info was sent successfully! We will get in touch shortly."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-primary",
        children: error.message
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex lg:hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AgentFormHeader, {})
    })]
  });
};

/* harmony default export */ var landing_AgentForm = (AgentForm);
// EXTERNAL MODULE: ./data/seo.json
var seo = __webpack_require__(35546);
;// CONCATENATED MODULE: ./pages/agents.jsx









var AgentsForm = function AgentsForm() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* default */.Z, {
      SEO: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(landing_AgentForm, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      src: "https://www.googleoptimize.com/optimize.js?id=OPT-WWVFB9W"
    })]
  });
};

/* harmony default export */ var agents = (AgentsForm);

/***/ }),

/***/ 15924:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents",
      function () {
        return __webpack_require__(52639);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15922:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72189)


/***/ }),

/***/ 46944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ c; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function r(e,t){return r=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},r(e,t)}var n=function(e){var t=document.createElement("script");t.async=!0,t.defer=!0,t.src=e,document.head&&document.head.appendChild(t)},i=function(e){return Array.from(document.scripts).reduce(function(t,r){return t||e.test(r.src)},!1)},o=/(http|https):\/\/(www)?.+\/recaptcha/,a=["sitekey","theme","size","badge","tabindex","hl","isolated"],c=/*#__PURE__*/function(t){var c,s;function p(){for(var r,a=arguments.length,c=new Array(a),s=0;s<a;s++)c[s]=arguments[s];return(r=t.call.apply(t,[this].concat(c))||this).container=void 0,r.timer=void 0,r.state={instanceKey:Date.now(),ready:!1,rendered:!1,invisible:"invisible"===r.props.size},r._isAvailable=function(){var e;return Boolean(null==(e=window.grecaptcha)?void 0:e.ready)},r._inject=function(){r.props.inject&&!i(o)&&n("https://recaptcha.net/recaptcha/api.js?render=explicit"+(r.props.hl?"&hl="+r.props.hl:""))},r._prepare=function(){var e=r.props,t=e.explicit,n=e.onLoad;window.grecaptcha.ready(function(){r.setState({ready:!0},function(){t||r.renderExplicitly(),n&&n()})})},r._renderRecaptcha=function(e,t){return window.grecaptcha.render(e,t)},r._resetRecaptcha=function(){return window.grecaptcha.reset(r.state.instanceId)},r._executeRecaptcha=function(){return window.grecaptcha.execute(r.state.instanceId)},r._getResponseRecaptcha=function(){return window.grecaptcha.getResponse(r.state.instanceId)},r._onVerify=function(e){return r.props.onVerify(e)},r._onExpire=function(){return r.props.onExpire&&r.props.onExpire()},r._onError=function(){return r.props.onError&&r.props.onError()},r._stopTimer=function(){r.timer&&clearInterval(r.timer)},r.componentDidMount=function(){r._inject(),r._isAvailable()?r._prepare():r.timer=window.setInterval(function(){r._isAvailable()&&(r._prepare(),r._stopTimer())},500)},r.componentWillUnmount=function(){r._stopTimer()},r.renderExplicitly=function(){return new Promise(function(e,t){if(r.state.rendered)return t(new Error("This recaptcha instance has been already rendered."));if(!r.state.ready||!r.container)return t(new Error("Recaptcha is not ready for rendering yet."));var n=r._renderRecaptcha(r.container,{sitekey:r.props.sitekey,theme:r.props.theme,size:r.props.size,badge:r.state.invisible?r.props.badge:void 0,tabindex:r.props.tabindex,callback:r._onVerify,"expired-callback":r._onExpire,"error-callback":r._onError,isolated:r.state.invisible?r.props.isolated:void 0,hl:r.state.invisible?void 0:r.props.hl});r.setState({instanceId:n,rendered:!0},function(){r.props.onRender&&r.props.onRender(),e()})})},r.reset=function(){return new Promise(function(e,t){if(r.state.rendered)return r._resetRecaptcha(),e();t(new Error("This recaptcha instance did not render yet."))})},r.execute=function(){return new Promise(function(e,t){return r.state.invisible?(r.state.rendered&&(r._executeRecaptcha(),e()),t(new Error("This recaptcha instance did not render yet."))):t(new Error("Manual execution is only available for invisible size."))})},r.getResponse=function(){return new Promise(function(e,t){if(r.state.rendered)return e(r._getResponseRecaptcha());t(new Error("This recaptcha instance did not render yet."))})},r.render=function(){var t=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{key:r.state.instanceKey,id:r.props.id,className:r.props.className,ref:function(e){return r.container=e}});return r.props.children?r.props.children({renderExplicitly:r.renderExplicitly,reset:r.reset,execute:r.execute,getResponse:r.getResponse,recaptchaComponent:t}):t},r}return s=t,(c=p).prototype=Object.create(s.prototype),c.prototype.constructor=c,r(c,s),p.getDerivedStateFromProps=function(e,t){var r="invisible"===e.size;return r!==t.invisible?{invisible:r}:null},p.prototype.componentDidUpdate=function(e){var t=this;a.reduce(function(r,n){return t.props[n]!==e[n]?[].concat(r,[n]):r},[]).length>0&&this.setState({instanceKey:Date.now(),rendered:!1},function(){t.props.explicit||t.renderExplicitly()})},p}(react__WEBPACK_IMPORTED_MODULE_0__.Component);c.defaultProps={id:"",className:"g-recaptcha",theme:"light",size:"normal",badge:"bottomright",tabindex:0,explicit:!1,inject:!0,isolated:!1,hl:""};
//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 27812:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 35546:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"The Future of Business Banking & Payments","description":"On-Chain Financial Infrastructure For Today’s Businesses"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,7258,5675,2580,6770,646,9530,8523,7965,4964,9774,2888,179], function() { return __webpack_exec__(15924); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);